/* ============
 * Mutation types for the profile module
 * ============
 *
 * The mutation types that are available
 * on the profile module.
 */
import keyMirror from 'key-mirror';

export default keyMirror({
  SET_GROUP: null,

  CREATE_GROUP: null,
  CREATE_GROUP_SUCCESS: null,
  CREATE_GROUP_FAIL: null,

  FETCH_ALL_GROUPS: null,
  FETCH_ALL_GROUPS_SUCCESS: null,
  FETCH_ALL_GROUPS_FAIL: null,

  EDIT_START: null,
  EDIT_SAVE_SUCCESS: null,
  EDIT_CANCEL: null,
  EDIT_FAIL: null,

  FETCH_GROUP_USERS: null,
  FETCH_GROUP_USERS_SUCCESS: null,
  FETCH_GROUP_USERS_FAIL: null,

  ASSIGN_UNASSIGN_GROUP_PATIENT_BEGIN: null,
  ASSIGN_GROUP_PATIENT: null,
  ASSIGN_GROUP_PATIENT_FAIL: null,
  UNASSIGN_GROUP_PATIENT: null,
  UNASSIGN_GROUP_PATIENT_FAIL: null,

  FETCH_GROUP_INFO: null,
  FETCH_GROUP_INFO_SUCCESS: null,
  FETCH_GROUP_INFO_FAIL: null,

  CLEAR_STATE: null,
  GROUP_USER_SELECT_ITEMS: null,
  GROUP_USERS_SELECT_ONE_ITEM: null,

  GROUP_USER_ASSIGN_UNASSIGN_ALL: null,
  GROUP_USER_ASSIGN_UNASSIGN_ALL_START: null,
  GROUP_USER_ASSIGN_UNASSIGN_ALL_SUCCESS: null,
  GROUP_USER_ASSIGN_UNASSIGN_ALL_FAIL: null,

});
